/**
 * Make an HTTP request with the Fetch API and cache results
 * @param input API endpoint
 * @param settings HTTP Fetch configuration
 */
export function cachedFetch<T>(
  input: RequestInfo,
  settings?: RequestInit
): Promise<T> {
  const storage = sessionStorage;
  return new Promise((resolve, reject) => {
    const key = `uppload_cache_${JSON.stringify(input)}`;
    const maxTTL = new Date();
    maxTTL.setDate(maxTTL.getDate() + 1);
    const cachedResult = storage.getItem(key);
    if (cachedResult) {
      const cachedResultData = JSON.parse(cachedResult);
      if (
        cachedResultData.ttl &&
        new Date(cachedResultData.ttl).getTime() > new Date().getTime()
      )
        return resolve(cachedResultData.result);
    }
    window
      .fetch(input, settings)
      .then(response => {
        if (!response.ok) throw new Error("errors.response_not_ok");
        return response.json();
      })
      .then(result => {
        storage.setItem(
          key,
          JSON.stringify({
            ttl: maxTTL,
            updatedAt: new Date(),
            result
          })
        );
        resolve(result);
      })
      .catch(error => reject(error));
  });
}

/**
 * Create a file extension to pass to weserv
 * @param filetype
 */
const createWeservExt = (filetype: string) => {
  console.log(filetype);
  if (filetype === "image/jpg" || filetype === "image/jpeg") {
    return "&output=jpg";
  } else if (filetype === "image/gif") {
    return "&output=gif&n=-1";
  } else if (filetype === "image/png") {
    return "&output=png";
  } else if (filetype === "image/webp") {
    return "&output=webp";
  } else if (filetype === "image/tiff") {
    return "&output=tiff";
  }

  return "";
};

/**
 * Get a file Blob from an image URL
 * @param url - URL of an image
 */
export const imageUrlToBlob = (
  url: string,
  filetype: string
): Promise<Blob> => {
  return new Promise((resolve, reject) => {
    console.log(filetype);
    console.log(
      `https://images.weserv.nl/?url=${encodeURIComponent(
        url
      )}${createWeservExt(filetype)}`
    );
    window
      .fetch(
        `https://images.weserv.nl/?url=${encodeURIComponent(
          url
        )}${createWeservExt(filetype)}`
      )
      .then(response => {
        if (!response.ok) throw new Error("errors.response_not_ok");
        return response.blob();
      })
      .then(blob => resolve(blob))
      .catch(error => reject(error));
  });
};
